export default {
  'no-recipes': 'Aucune recette trouvée pour cette catégorie',
};
